import { render, staticRenderFns } from "./CaptationUnities.vue?vue&type=template&id=8c6530f0&scoped=true&"
import script from "./CaptationUnities.vue?vue&type=script&lang=js&"
export * from "./CaptationUnities.vue?vue&type=script&lang=js&"
import style0 from "./CaptationUnities.vue?vue&type=style&index=0&id=8c6530f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6530f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VForm,VIcon,VSelect,VSpacer,VTextField})
